<!--企业用户d-center-between h6 member-wrap-->
<template>
  <div>
        <!--头部导航-->
        <headerNav :category="2"></headerNav>
        <!--登录内容-->
        <div class="login-content" :style="{backgroundImage: `url(${require('@/assets/images/background3.jpg')})`}">
            <div class="login-content-box">
                <div class="login-content-box-item">
                <!--常规登录-->
                <!--切换登录方式-->
                    <div class="EnterpriseLogin-title">
                        <p class="one">企业登录</p>
                        <p class="two"></p>
                    </div>
                <!--登录表单-->
                <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline full-form"  @keyup.enter.native="submitForm('formInline')">
                    <el-form-item prop="username">
                    <el-input v-model.trim="formInline.username"
                        type="text"
                        placeholder="请输入企业账户"
                        prefix-icon="el-icon-user"
                        clearable
                        />
                    </el-form-item>
    
                    <!--输入密码登录-->
                    <el-form-item prop="password"  class="password" :rules="isPhoneValid ? rules.password : []" v-if="activeTab==='account'">
                    <el-input :type="openEye ? 'text' :'password'"
                                v-model.trim="formInline.password"  
                                prefix-icon="el-icon-lock"
                                placeholder="请输入密码"
                                class="mt-2"
                                >
                        <i slot="suffix" v-if="formInline.password!=''"  class="el-input__icon iconfont cursor-pointer" @click="openEye = !openEye" :class="[openEye ? 'icon-bukanmima' :'icon-chakanmima']"></i>
                    </el-input>
                    </el-form-item>
                    <el-alert
                      class="alert mt-2"
                      :title="alertTitle"
                      type="error"
                      :closable="false"
                      v-if="alertShow"
                      show-icon>
                    </el-alert>
                    <div class="forgot-password">
                      <router-link :to="{name:'StoreApplication'}"><p>企业申请注册</p></router-link>
                    </div>
                    <!--协议-->
                    <div class="agreement" :class="{'agreement-list-tips':alertShow}">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <div class="agreement-lon" v-if="agreeDisabled">
                        <div class="agreement-list-tips-arrow"></div>
                        请阅读并勾选协议
                    </div>
                    <p>我已阅读并同意订单雨 <router-link  :to="{name:'regDoc',query:{anch:'0'}}">《隐私条款》</router-link>和<router-link :to="{name:'regDoc',query:{anch:'1'}}">《服务条款》</router-link></p>
                    </div>
                    <el-button class="mt-3" :loading="loading" type="primary" style="width: 100%;" @click="submitForm('formInline')"  block>登 录</el-button>
                </el-form>
                <!--其他登录方式-->
                <!-- <div class="wx-login mt-3">
                    <p>其他登录</p>
                    <div>
                    <i class="icon-weixin iconfont"></i>
                    </div>
                </div> -->
                </div>
            </div>
        </div>
        <!--登录底部导航-->
        <bottom-nav></bottom-nav>
        <!--图形验证码-->
        <Vcode
          :show="isShow"
          @success="success"
          @close="isShow = false"
        />
  </div>
</template>

<script>
import BottomNav from './components/BottomNav.vue'
import HeaderNav from './components/HeaderNav.vue'
import { mapActions } from 'vuex'
import { debounce } from "lodash";
import Vcode from "vue-puzzle-vcode";
export default {
  name: 'EnterpriseLogin',
  components: {
    BottomNav,
    HeaderNav,
    Vcode
  },
  props: {},
  data() {
    return {
      activeTab: 'account', // 默认选中的tab
      LoginMethod:true,     //切换登录方式
      formInline: {
        username: '',
        password:'', 
      },

      openEye:false,           //密码可见
      rules: {                 //表单验证规则
          username: [
            { required: true, message: '请输入企业账户', trigger: 'blur' },
  
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
          ],
      },
      phoneValid: false, // 手机号验证通过
      checked:true,            //默认选中协议
      agreeDisabled: false, // 协议提示
      alertShow:false,         //提示信息是否显示
      alertTitle:'',          //提示信息标题
      loading:false,           //登录按钮loading状态
      isShow:false,            //图形验证是否显示
      loginCount:0,            //登录次数
    };
  },
  computed: {
      // 判断手机号是否合法
      isPhoneValid() {
        const reg = /^[a-zA-Z0-9]+$/;
        return reg.test(this.formInline.username)
      },
  },
  watch: {},
  created() {},
  mounted() {
    // 刷新页面判断如果获取登录数量值/过10分钟不计数
    const EXPIRE_TIME = 10 * 60 * 1000;
    const str = localStorage.getItem('verify_record');
    if(str){
      const record = JSON.parse(str);
      if(record.time + EXPIRE_TIME > Date.now()){
        this.loginCount = record.count;
      }
    }
  },
  methods: {  
    ...mapActions(['UserLogin']),
      getCode() {
      // 关键：只单独校验账户字段
      this.$refs.formInline.validateField('username', valid => {
          if (!valid) {
            return // 直接阻止，不发验证码请求
          }
        // valid 为 false 说明手机号校验不通过，已经自动弹出红色提示
      })
    },
    // 登录验证
    submitForm: debounce(async function(formName) {
      await this.$refs[formName].validate(async valid => {
        if (valid) {
          //未勾选协议提示
          if(!this.checked){
            this.agreeDisabled=true;
            return
          }else{
            this.agreeDisabled=false;
          }
          //如果登录次数超过5次,显示图形验证
          if(this.loginCount>=3){
            this.isShow=true;
            return
          }
          //验证通过登录
          await this.POST_UserLogin();
        } else {
          return false;
        }
      });
    },500),
    //图形验证成功
    success() {
      this.isShow = false;
      this.POST_UserLogin();
    },
    //用户登录
    async POST_UserLogin(){
      //验证通过
      this.loading = true;
      let url = '/pc/Reglogin/LoginEnterprise';
      let data = {
        needType: 1,
        ...this.formInline
      }
      let res = await this.UserLogin({url,data,type: 'user'});
      if (res&&res.code != '00000') {
        this.alertShow=true;
        this.alertTitle=res.msg;
        this.loginCount++;
          const newRecord = {
            count: this.loginCount,
            time: new Date().getTime()
          };
          localStorage.setItem('verify_record', JSON.stringify(newRecord));
      }
      this.loading = false;
    },
  }
};
</script>

<style lang="scss" scoped>
  .text-primary{
    cursor: pointer;
  }
  .login-content{
    height: 500px;
    width: 100%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: scroll;
    overflow: hidden;
  }
  .login-content-box{
    width: 1200px;
    margin: 0 auto;
  }
  .login-content-box-item{
    width: 340px;
    padding: 0 30px;
    height: 400px;
    background-color: #fff;
    float: right;
    margin-top: 50px;
    border-radius: 6px;
    box-shadow: 0px 1px 6px #999;
    position: relative;
  }
  .loginMethod{
    width: 100%;
    display: flex;
    margin-top: 40px;
    background-color: var(--smtc-color-back);
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    color: #999;
    position: relative;
    margin-bottom: 20px;
    p{
      width: 50%; 
      cursor: pointer;
    }
  }
  /* 滑块元素 */
  .tab-slider {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #1890ff;
    color: #fff;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    z-index: 1;
  }
  .cursor-pointer{
    font-size: 12px;
  }
  .agreement{
    font-size: 12px;
    display: flex;
    margin-top: 30px;
    position: relative;
    p{
      margin-left: 6px;
      color: #999;
      margin-top: -1.6px;
    }
  }
  .agreement-list-tips{
    margin-top: 15px;
  }
  .forgot-password{
    font-size: 12px;
    display: flex;
    justify-content: right;
    margin-top: 20px;
    p{
      cursor: pointer;
      color: #999;
      &:hover{
        color: var(--smtc-color-primary);
      }
    }
  }
  .agreement-lon{
    position: absolute;
    bottom: 100%;
    left: -8px;
    background: #142445;
    height: 22px;
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    line-height: 22px;
    padding: 5px 8px;
    border-radius: 3px;
    margin-bottom: 8px;
  }
  .agreement-list-tips-arrow{
    position: absolute;
    top: 100%;
    left: 10px;
    width: 0;
    height: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #142445 transparent transparent;
  }
  .wx-login{
    text-align: left;
    height: 60px;
    line-height: 60px;
    color: #999;
    display: flex;
    p{
      font-size: 12px;
      margin-right: 2%;
    }
  }
  .icon-weixin{
    font-size: 30px;
    color: #03db6c;
  }
  .weChatSwitch{
    position: absolute;
    right: -32px;
    top: 16px;
    width: 20px;
    padding: 6px;
    background-color: var(--smtc-color-primary);
    color: #fff;
    font-size: 12px;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    i{
      font-size: 14px;
      margin-top: 3px;
      display: inline-block;
    }
  }
  .EnterpriseLogin-title{
    text-align: left;
    margin-top: 36px;
  }
  .EnterpriseLogin-title .one{
    font-size: 24px;
    font-weight: bold;
  }
  .EnterpriseLogin-title .two{
    margin: 10px 0;
    color: #999;
    margin-bottom: 16px;
  }
</style>
<style>
    /* 让 el-input 直接占满整行 */
  .full-form  .el-form-item,.full-form .el-form-item__content{
    width: 100%;
  }
  .full-form .password {
    margin-bottom: 0px;
  }
  .alert .el-alert__title{
    font-size: 12px !important;
  }
</style>
